angular.module('unergie.main')
.controller('b2gHomeV2Ctrl', ($scope, $state, $filter, $uibModal, MS, DataAccess, CommonRegex, PrmValidationConstants, AuthService, ModalService, ApiAdmin,
    ApiUser, FileUploader, DataAccessSearch, AlertManager, MetaWatcher, BoFeaturesService, TableGeneratorService, ErrorCatcher, myAccounts) => {
    $scope.selected = {}
    $scope.shouldDisplayContactInfo = false
    $scope.canEditAdministrableContent = BoFeaturesService.isFeatureOn('canEditAdministrableContent')
    const b2gHomeFeatures = BoFeaturesService.getModuleFeatures('b2gHome')
    const canDLInvoices = b2gHomeFeatures.canDLInvoices.split(',')

    $scope.canDLInvoices = () => $scope.selected.account && canDLInvoices.includes($scope.selected.account.organization)

    $scope.removeButton = true

    $scope.openAdminContentModal = (contentId) => ModalService.openModal({ type: 'adminContentModal', size: 'xlg', backdrop: 'static' }, { contentId }, () => {
        // refresh content
    })

    $scope.stopProp = (e) => {
        e.stopPropagation()
    }

    $scope.refreshAccount = (account) => {
        if (account) {
            $scope.selected.account = account
        }
        MetaWatcher.notif('MNG_ACCOUNT_CHANGED')
    }

    $scope.casesTranslate = {
        COURS: 'Affaires ouvertes',
        ANNUL: 'Affaires annulées',
        TERMN: 'Affaires closes',
        ERROR: 'Retours ENEDIS en erreur des 30 derniers jours',
    }

    const computeAccountStats = (account) => {
        _.assign(account, {
            stats: {
                pdls: _.groupBy(account.pdls, 'status'),
            },
            incompleteCategories: _.filter(account.categories, { complete: false }),
        })
    }

    const fetchAccountInfo = () => {
        $scope.selected.account.fetching = true
        return DataAccess.myAccount({ id: $scope.selected.account.id, light: true }).$promise
        .then((accountDetails) => {
            _.assign($scope.selected.account, accountDetails.toJSON(), { fetched: true })
            computeAccountStats($scope.selected.account)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.selected.account.fetching = false
        })
    }

    const updateAccount = (force) => {
        if ($scope.selected.account && (!$scope.selected.account.fetched || force)) {
            fetchAccountInfo()
        }
    }

    const updatePage = () => {
        const selectedId = $scope.selected.account && $scope.selected.account.id
        $scope.updatingPage = true
        return DataAccess.myAccounts({ light: true }).$promise
        .then((accounts) => {
            $scope.accounts = accounts
            if (!selectedId) {
                $scope.selected = {
                    account: $scope.accounts[0],
                }
            } else {
                $scope.selected = {
                    account: _.find($scope.accounts, { id: selectedId }),
                }
            }
            updateAccount()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.updatingPage = false
        })
    }

    MetaWatcher.watch('MNG_ACCOUNT_CHANGED', 'b2gHome', $scope, updateAccount)

    $scope.displayContactInfo = () => {
        $scope.shouldDisplayContactInfo = !$scope.shouldDisplayContactInfo
    }

    $scope.goTo = (page, params) => {
        const url = $state.href(page, params)
        window.open(url, '_blank')
    }

    const updateNbTicketStatusWaiting = () => {
        // Fetch project epic issue
        $scope.fetchingZendeskB2gTickets = true
        return ApiAdmin.fetchZendeskB2gTickets({ filter: { status: 'pending' }, limit: 1 }, AuthService.getAuth().organization).$promise.then((response) => {
            $scope.nbTicketStatusWaiting = response.count
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.fetchingZendeskB2gTickets = false
        })
    }

    $scope.openNewZendeskB2gModal = () => {
        ModalService.openModal({ type: 'newZendeskB2gModal', size: 'md' }, { accounts: myAccounts }, $scope.renderTable)
    }

    $scope.openTemporaryConnectionModal = () => {
        ModalService.openModal({ type: 'temporaryConnectionModal', size: 'lg' }, { id_account: $scope.selected.account.id })
    }

    // INVOICES EXCEL
    $scope.invoicesExcelTemplate = {
        month: undefined,
    }

    $scope.invoicesExcelFields = {
        startMonth: {
            label: 'Début',
            type: 'select',
            required: true,
            enum: [],
        },
        endMonth: {
            label: 'Fin',
            type: 'select',
            required: true,
            enum: [],
            check: (template) => moment(template.startMonth).isSameOrBefore(moment(template.endMonth)),
        },
        dateCheck: {
            hidden: (template) => $scope.invoicesExcelFields.startMonth.hidden || (moment(template.startMonth).isSameOrBefore(moment(template.endMonth))),
            label: '<span class="red"><span class="fa fa-warning"></span> Veuillez choisir une date de fin antérieure à la date de début.</span>',
            type: 'label',
        },
        noInvoicePeriod: {
            label: 'Aucune période de facturation disponible',
            type: 'label',
        },
    }

    $scope.generateInvoicesExcelTemplate = () => {
        $scope.fetchingInvoicedPeriods = true
        return DataAccess.availableMetaPeriods({ id_account: $scope.selected.account.id }).$promise
        .then((periods) => {
            if (periods.start.length || periods.end.length) {
                $scope.invoicesExcelFields.noInvoicePeriod.hidden = true
                $scope.invoicesExcelFields.startMonth.hidden = false
                $scope.invoicesExcelFields.endMonth.hidden = false
                $scope.invoicesExcelFields.startMonth.enum = periods.start
                $scope.invoicesExcelFields.endMonth.enum = periods.end
                $scope.removeButton = false
            } else {
                $scope.invoicesExcelFields.startMonth.hidden = true
                $scope.invoicesExcelFields.endMonth.hidden = true
                $scope.invoicesExcelFields.noInvoicePeriod.hidden = false
                $scope.removeButton = true
            }
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.fetchingInvoicedPeriods = false
        })
    }

    $scope.dlInvoicesForMonth = () => {
        window.open(`/api-user/b2g-account/${$scope.selected.account.id}/billing-xlsx` +
            `?startMonth=${$scope.invoicesExcelTemplate.startMonth}&endMonth=${$scope.invoicesExcelTemplate.endMonth}&v=2`, '_blank')
    }

    // DL PERIMETER

    const PERIMETER_COLS = [
        'lot',
        'groupement',
        'id_grapp',
        'numero_marche',
        'type_approvisionement',
        'frequence_facturation',
        'mode_reglement',
        'paquet_facturier',
        'id_interne',
        'numero_pdl',
        'adresse_rue',
        'adresse_code_postal',
        'adresse_ville',
        'puissance_souscrite',
        'offre_fournisseur',
        'tarif_acheminement',
        'type_compteur',
        'numero_compteur',
        'statut',
        'date_activation',
        'date_resiliation',
    ]

    $scope.dlPerimeter = () => {
        const handler = {}
        TableGeneratorService.getTable(handler, 'b2g-contracts', null, null, { search: { id_account: $scope.selected.account.id }, columns: PERIMETER_COLS })
        handler.instance.csv('perimetre.csv')
    }

    const activate = () => {
        updatePage().then(() => {
            updateNbTicketStatusWaiting()
        })
    }

    activate()
})
